/**
 * @param {string} query
 * @returns {{ name: string, value: string }[]}
 */
export default function parseQuery(query) {
    if (typeof query !== 'string') {
        throw new Error(`${parseQuery.name}: ${query} is not a string`);
    }

    /** @type {{ name: string, value: string }[]} */
    const result = [];

    (new URLSearchParams(query))
        .forEach((value, name) => result.push({ name, value: encodeURI(value) }));

    return result;
}
